module.exports = __webpack_public_path__ + "tablecenteralignment.06048615ef6bc40c48a4.svg";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/documenteditor/tablecenteralignment.svg
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/documenteditor/tablecenteralignment.svg
// module chunks = 2